import { fetchTimetable, type TimetableLocation, type TimetableSession } from "../../lib/api";
import { monthFetchRange, type YearMonth } from "./lib";

export const PAGE_LIMIT = 100;
export const MAX_PAGES = 10;

export async function fetchMonthSessions(
  opts: { school: string; ym: YearMonth; apiUrl?: string },
  fetchImpl: typeof fetchTimetable = fetchTimetable,
): Promise<{ sessions: TimetableSession[]; locations: TimetableLocation[] }> {
  const { from, to } = monthFetchRange(opts.ym);
  const all: TimetableSession[] = [];
  let locations: TimetableLocation[] = [];
  for (let page = 1; page <= MAX_PAGES; page++) {
    const res = await fetchImpl(
      opts.school,
      { from, to, page, limit: PAGE_LIMIT },
      opts.apiUrl,
    );
    if (page === 1) locations = res.locations ?? [];
    // fallbackSessions are "nothing in range" suggestions — never month content
    all.push(...(res.sessions ?? []));
    // The API applies skip/limit to the raw session query, then filters items
    // out per-page (approval, ticket availability, etc.) — a full DB page can
    // come back with fewer than PAGE_LIMIT *returned* sessions even though
    // more pages remain. `total` is the raw base-query count, so drive paging
    // off it; only fall back to the short-page heuristic if it's missing.
    if (res.total == null) {
      if ((res.sessions?.length ?? 0) < PAGE_LIMIT) break;
    } else if (page * PAGE_LIMIT >= res.total) {
      break;
    }
  }
  return { sessions: all.filter((s) => !s.cancelled), locations };
}
